// WebSocket host for the ESR realtime (AppSync) connection. Mocked in Jest
export function getViteAppEsrWssUrl(): string {
  return import.meta.env.VITE_ESR_WSS_URL;
}
